import { createContext } from 'react';
export const AllProfilesContext = createContext();